module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDAgMAAAAXJUhJAAAACVBMVEVV3P////8AzP/CytnkAAAAAXRSTlPA24Ia1gAAACFJREFUOMtjCMUFRmVGZUZlKJDBDVbhAqMyozKjMuTLAACTyjX16UYLLgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/flag/100px-Flag_of_Santa_Marta.svg.png
// module id = zxwS
// module chunks = 1